var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconBatteryLine(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_740_791)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.31095 3.73554V22.1379C5.31198 23.1662 6.14474 23.999 7.17301 24H16.8268C17.8551 23.999 18.6878 23.1662 18.6889 22.1379V3.73554C18.6878 2.70726 17.8551 1.87451 16.8268 1.87348H14.9451V1.44829C14.944 0.648644 14.2964 0.00105931 13.4968 0H10.5029C9.70324 0.00103442 9.05565 0.648618 9.05459 1.44829V1.87348H7.17285C6.14458 1.87451 5.31198 2.70726 5.31095 3.73554ZM6.55233 3.73554C6.55233 3.39311 6.82958 3.11483 7.17304 3.11483H9.67649H9.67545C10.0179 3.11483 10.2962 2.83655 10.2962 2.49413V1.44827C10.2962 1.33447 10.3893 1.24137 10.5031 1.24137H13.4969C13.6107 1.24137 13.7038 1.33447 13.7038 1.44827V2.49413C13.7038 2.83655 13.9821 3.11483 14.3245 3.11483H16.827C17.1704 3.11483 17.4477 3.39311 17.4477 3.73554V22.1379C17.4477 22.4804 17.1704 22.7586 16.827 22.7586H7.17317C6.82971 22.7586 6.55246 22.4804 6.55246 22.1379L6.55233 3.73554Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_740_791"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBatteryLine);
export default __webpack_public_path__ + "static/media/icon-battery-line.ea8837047ea07a118ca9629d0f72176f.svg";
export { ForwardRef as ReactComponent };